@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

// A SocialButton IS a cxy Button: `SocialButton` renders `Button` and adds one of these classes to
// it. So every property declared here that `Button` also declares is two single-class rules
// fighting over one element, and the winner is whichever stylesheet the bundler emits last.
//
// That order reversed when cxy moved from a published tarball to workspace source (NGF-7035),
// because `SocialButton.tsx` imports `../Button` above its own stylesheet. It silently restyled the
// Google button on /plus in production — a filled pill at radius 94px became transparent with a 1px
// border at radius 9999px — and nothing failed, because the rules and class names were unchanged.
//
// So this file no longer declares `background`, `border` or `border-radius` — `Button` owns those —
// and anything that MUST beat `Button` says so with a doubled class rather than by hoping it is
// emitted second. (`align-items` / `justify-content` below duplicate `Button`'s own values; only
// `gap` is genuinely absent from it. Identical values, so nothing there is order-dependent.)
// The behaviour is asserted in `tests/SocialButton.spec.tsx`.
.facebookButton,
.googleButton {
  gap: var(--cxy-spacing-xxsm);
  align-items: center;
  justify-content: center;
}

// Brand colour is the one thing Facebook must win: doubled class (0,2,0) beats `Button`'s variant
// (0,1,0) in any order. Note this never rendered before — `Button`'s variant was winning — and the
// button is not shown in the login flow (asserted in myoc-login's SocialButtons.spec.tsx).
.facebookButton.facebookButton {
  background-color: #1877f2;
  color: var(--cxy-color-text-default-body);

  &[disabled] {
    background-color: #1877f2;
  }
}

.facebookButton {
  span {
    @include cxy.font-size('text-m');
    font-weight: bold;
    color: inherit;
  }
}

// Deliberately no `background`, `border` or `border-radius`: those are `Button`'s, and declaring
// them here is what changed the live Google button. Only the drop shadow and typography are
// social-specific.
.googleButton {
  box-shadow: var(--cxy-box-shadow-a);

  span {
    @include cxy.font-size('text-m');
    color: inherit;
  }

  &:hover {
    color: var(--cxy-color-text-default-body);
  }
}
